import React from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import { X } from "react-feather"
import s from "./ModalCloseButton.module.scss"

/**
 * Dismiss control for a reactstrap `ModalHeader`'s `close` slot.
 *
 * Passing a bare `<X />` there leaves it unstyled — the theme's rules are
 * scoped to `.close`, which a raw SVG never gets — so it inherits
 * `.modal-header`'s vertical centring and drifts out of the corner as soon as
 * the title runs to two lines. This pins it to the top right and gives it a
 * real hit area.
 *
 * @example
 * <ModalHeader toggle={onClose} close={<ModalCloseButton onClick={onClose} />}>
 */
const ModalCloseButton = ({ onClick, label = "Close", className }) => (
  <button type="button" className={cx(s.close, className)} aria-label={label} onClick={onClick}>
    <X size={18} aria-hidden="true" />
  </button>
)

ModalCloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  /** Accessible name; override when "Close" is ambiguous. */
  label: PropTypes.string,
  className: PropTypes.string
}

export default ModalCloseButton
